/* global femcare */

femcare.accessibility = {
    init() {
        this.initBypassNavigation();
    },

    /**
     * Find all bypass links and wire up click and focus/blur handlers.
     * @private
     */
    initBypassNavigation() {
        /**
         * Handle click on a bypass link to move focus to its paired target.
         * @param {HTMLElement} button - The link button that was clicked.
         * @param {string} targetSelector - Selector for the target element within the same parent.
         */
        const handleBypassClick = (button, targetSelector) => {
            button.addEventListener('click', e => {
                e.preventDefault();
                const target = button.parentElement.querySelector(targetSelector);
                if (target) {
                    target.focus();
                }
            });
        };

        /**
         * Show button when focused and hide when blurred.
         * @param {HTMLElement} button - The link button to wire up.
         */
        const handleFocusAndBlur = button => {
            button.addEventListener('focus', () => button.classList.remove('invisible'));
            button.addEventListener('blur', () => button.classList.add('invisible'));
        };

        /**
         * Initialize bypass behavior for a list of buttons.
         * @param {NodeListOf<HTMLElement>} buttonList - Collection of buttons to initialize.
         * @param {string} targetSelector - Selector of the focus target relative to each button.
         */
        const initBypassBehavior = (buttonList, targetSelector) => {
            buttonList.forEach(btn => {
                handleBypassClick(btn, targetSelector);
                handleFocusAndBlur(btn);
            });
        };

        const bypassStartLinks = document.querySelectorAll('.bypass-block--start');
        const bypassEndLinks = document.querySelectorAll('.bypass-block--end');

        initBypassBehavior(bypassStartLinks, '.bypass-block--end');
        initBypassBehavior(bypassEndLinks, '.bypass-block--start');

        // Single skip-to-main link
        const skipToMainLink = document.querySelector('.bypass-block--main');

        if (skipToMainLink) {
            skipToMainLink.addEventListener('click', e => {
                e.preventDefault();
                const mainTarget = document.querySelector(skipToMainLink.getAttribute('href'));

                if (mainTarget) {
                    if (!mainTarget.hasAttribute('tabindex')) {
                        mainTarget.setAttribute('tabindex', '-1');
                    }
                    mainTarget.focus();
                }
            });

            handleFocusAndBlur(skipToMainLink);
        }
    }
};
